import { Mutation, VisitorGroup } from 'graphql/generated/graphqlTypes';

export function mockedSetIsAdminForGroup(groupId: string): Pick<Mutation, 'setIsAdminForGroup'> {
  return {
    setIsAdminForGroup: { id: groupId } as VisitorGroup
  };
}

export const mockedSetIsAdminForGroupDataForMutation = mockedSetIsAdminForGroup('mockedVisitorGroupId1');
